import React, { useId } from 'react'
import { SuperGrain } from '../SuperGrain'

export const MessyHorizontal = ({
  hideGrain,
  svgProps,
}: {
  hideGrain?: boolean
  svgProps: React.SVGProps<SVGSVGElement>
}) => {
  const uniqueId = useId()
  const maskId = `grainFilter-messy-horizontal-${uniqueId}`

  return (
    <svg
      {...svgProps}
      viewBox="0 0 2999 1781"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4716_2159)">
        <g filter="url(#filter0_f_4716_2159)">
          <path
            d="M4527.63 846.764L-842.572 1001.11L-352.802 758.364L2190.63 819.752L4527.63 846.764Z"
            fill="#EBBCCB"
          />
        </g>
        <g filter="url(#filter1_f_4716_2159)">
          <path
            d="M8363.15 685.434L-4405.51 946.042L-3240.99 536.176C-3240.99 536.176 -495.22 1333.64 1940.94 376.835C2218.35 267.88 2514.23 211.121 2810.51 243.479C3936.4 366.445 6883.55 673.29 8363.15 685.434Z"
            fill="#176BE5"
          />
        </g>
        <path
          d="M314.481 601.197C314.967 601.274 315.489 601.361 315.975 601.438C315.489 601.416 314.967 601.394 314.481 601.383L314.481 601.197Z"
          fill="white"
        />
        <g filter="url(#filter2_f_4716_2159)">
          <path
            d="M-419.438 1082.42L4950.76 781.748L4460.99 1254.62L1917.56 1135.04L-419.438 1082.42Z"
            fill="#BACBE7"
          />
        </g>
        <g filter="url(#filter3_f_4716_2159)">
          <path
            d="M1510.15 1066.91L3928.77 878.653L3634.08 1374.97L2527.19 1161.04L1510.15 1066.91Z"
            fill="#F97B4F"
          />
        </g>
        <g filter="url(#filter4_f_4716_2159)">
          <path
            d="M2536.48 1304.86L-1347.86 1248.58L-1053.17 1686.17C-1053.17 1686.17 1150.47 1450.72 1519.43 1387.85L2536.48 1304.86Z"
            fill="#FFD2E1"
          />
        </g>
        <g filter="url(#filter5_f_4716_2159)">
          <path
            d="M1648.89 1172.78L4067.51 1219.73L3772.82 1095.95L2665.94 1149.31L1648.89 1172.78Z"
            fill="#F97B4F"
          />
        </g>
        <g filter="url(#filter6_f_4716_2159)">
          <path
            d="M835.77 468.785L-58.2364 993.234L835.77 1437.68L1491.97 1437.68L1491.97 661.422L835.77 468.785Z"
            fill="url(#paint0_linear_4716_2159)"
            fillOpacity="0.41"
          />
        </g>
        <g filter="url(#filter7_f_4716_2159)">
          <path
            d="M2058.35 1228.3L-360.275 1062.31L-65.5839 1499.91L1041.3 1311.29L2058.35 1228.3Z"
            fill="#F97B4F"
          />
        </g>
        <g filter="url(#filter8_f_4716_2159)">
          <path
            d="M675.304 380.388L6045.51 226.04L5555.74 468.787L3012.3 407.399L675.304 380.388Z"
            fill="#EBBCCB"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4716_2159"
          x="-973.719"
          y="627.218"
          width="5632.49"
          height="505.04"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="65.5733"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter1_f_4716_2159"
          x="-4630.33"
          y="9.61018"
          width="13218.3"
          height="1161.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="112.411"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter2_f_4716_2159"
          x="-488.134"
          y="713.052"
          width="5507.59"
          height="610.268"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="34.3479"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter3_f_4716_2159"
          x="1457.06"
          y="825.57"
          width="2524.79"
          height="602.487"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="26.5416"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter4_f_4716_2159"
          x="-1510.23"
          y="1086.2"
          width="4209.09"
          height="762.339"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="81.186"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter5_f_4716_2159"
          x="1548.97"
          y="996.031"
          width="2618.47"
          height="323.623"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="49.9606"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter6_f_4716_2159"
          x="-343.527"
          y="183.494"
          width="2120.79"
          height="1539.47"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="142.645"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter7_f_4716_2159"
          x="-522.647"
          y="899.941"
          width="2743.37"
          height="762.339"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="81.186"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <filter
          id="filter8_f_4716_2159"
          x="544.158"
          y="94.8934"
          width="5632.49"
          height="505.04"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="65.5733"
            result="effect1_foregroundBlur_4716_2159"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4716_2159"
          x1="248.08"
          y1="1063.17"
          x2="1070.16"
          y2="1068.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEBACB" stopOpacity="0.9" />
          <stop offset="1" stopColor="#EEBACB" />
        </linearGradient>
        <clipPath id="clip0_4716_2159">
          <rect
            width="2998"
            height="1781"
            fill="white"
            transform="translate(0.818359)"
          />
        </clipPath>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="black" />
          <g filter="url(#filter0_f_4716_2159)">
            <path
              d="M4527.63 846.764L-842.572 1001.11L-352.802 758.364L2190.63 819.752L4527.63 846.764Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter1_f_4716_2159)">
            <path
              d="M8363.15 685.434L-4405.51 946.042L-3240.99 536.176C-3240.99 536.176 -495.22 1333.64 1940.94 376.835C2218.35 267.88 2514.23 211.121 2810.51 243.479C3936.4 366.445 6883.55 673.29 8363.15 685.434Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter2_f_4716_2159)">
            <path
              d="M-419.438 1082.42L4950.76 781.748L4460.99 1254.62L1917.56 1135.04L-419.438 1082.42Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter3_f_4716_2159)">
            <path
              d="M1510.15 1066.91L3928.77 878.653L3634.08 1374.97L2527.19 1161.04L1510.15 1066.91Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter4_f_4716_2159)">
            <path
              d="M2536.48 1304.86L-1347.86 1248.58L-1053.17 1686.17C-1053.17 1686.17 1150.47 1450.72 1519.43 1387.85L2536.48 1304.86Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter5_f_4716_2159)">
            <path
              d="M1648.89 1172.78L4067.51 1219.73L3772.82 1095.95L2665.94 1149.31L1648.89 1172.78Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter7_f_4716_2159)">
            <path
              d="M2058.35 1228.3L-360.275 1062.31L-65.5839 1499.91L1041.3 1311.29L2058.35 1228.3Z"
              fill="white"
            />
          </g>
          <g filter="url(#filter8_f_4716_2159)">
            <path
              d="M675.304 380.388L6045.51 226.04L5555.74 468.787L3012.3 407.399L675.304 380.388Z"
              fill="white"
            />
          </g>
        </mask>
      </defs>
      {!hideGrain && (
        <foreignObject
          x="0"
          y="0"
          width="100%"
          height="100%"
          mask={`url(#${maskId})`}
        >
          <SuperGrain zIndex={0} />
        </foreignObject>
      )}
    </svg>
  )
}
